'use strict';
import { FieldsList, FieldPreset, InsertField } from './edit_field.js'
import { JpZip } from './jp_zip.js'
import { notifications, Notifications } from './notifications.js'
import flatpickr from "flatpickr"
import("flatpickr/dist/themes/material_blue.css");
import Selectr from 'mobius1-selectr'
import("mobius1-selectr/dist/selectr.min.css");
import 'babel-polyfill';
import mailcheck from 'mailcheck';
import { showLoading, hideLoading } from './loading.js';
import darkmode from './darkmode.js'

window.addEventListener('DOMContentLoaded', () => {
  // for copy btn
  const copyBtn = document.querySelectorAll('.js-copyBtn');
  const copyText = el => {
    el.addEventListener('click', () => {
      const target = document.querySelector(el.dataset.target);
      const text = target.textContent.trim();
      navigator.clipboard.writeText(text);
    });
  };

  if (copyBtn.length > 0) {
    for (let i = 0; i < copyBtn.length; i++) {
      copyText(copyBtn[i]);
    }
  }

  const domains = ['docomo.ne.jp', 'ezweb.ne.jp', 'softbank.ne.jp', 'i.softbank.jp', 'gmail.com', 'aol.com', 'yahoo.co.jp', 'outlook.jp', 'hotmail.com', 'live.com', 'icloud.com'];
  const secondLevelDomains = ['hotmail', 'docomo', 'ezweb', 'softbank', 'yahoo', 'icloud', 'outlook']
  const topLevelDomains = ['com', 'net', 'org', 'edu', 'gov', 'mil', 'biz', 'info', 'ac.jp', 'ad.jp', 'co.jp', 'ed.jp', 'go.jp', 'lg.jp', 'ne.jp', 'jp'];

  var inputTimer;
  $('.visitors').on('keyup', '[id^="charge_visitors_attributes"][type="email"]', function(){
    if(inputTimer)clearTimeout(inputTimer);
    var el = $(this);
    inputTimer = setTimeout(function(){
      el.mailcheck({
        email: el.val(),
        domains: domains,
        topLevelDomains: topLevelDomains,
        secondLevelDomains: secondLevelDomains,
        suggested: function (element, suggestion) {
          const message = $('.email-suggest-message').text().replace('*', suggestion.full);
          if (element.next('.suggestion').length > 0) {
            element.next('.suggestion').text(message);
          } else {
            element.after(`<p class="suggestion">${message}</p>`);
          }
        },
        empty: function (element) {
          element.next('.suggestion').remove();
        }
      });
    }, 700);
  });

  $('.l-gHeader .l-gHeader-inner .menu-btn').on('click', function () {
    $('.navRight').toggleClass('active');
  });

  $('.l-gHeader .l-gHeader-inner .toggle-menu').on('click', function () {
    $('.sidebar-inner').toggleClass('active');
  });


  flatpickr(".date_time_picker_wrap", {
    enableTime: true,
    altInput: true,
    altFormat: "Y/m/d H:i",
    dateFormat: "Y-m-dTH:i:00",
    time_24hr: true,
    wrap: true,
  });

  $('input[name="iframe-height"]').on('change', function(){
    var h = $(this).val();
    var codeblock = $('#js-codeBlock');
    var str = codeblock.val();
    str = str.replace(/min-height: .+px/g, 'min-height: '+h+'px');
    codeblock.val(str);
  });

  $('.close-btn').on('click',function(){ $(this).parent().addClass('closing'); });

  $('.edit').on('click', '.editParts-name', function(e){
    e.preventDefault();
    $('.editPartsDialogue').addClass('hidden');
    $('body').addClass('no-scroll');

    var $dialogue = $(this).parent().parent().next();
    $dialogue.removeClass('hidden');
    $('.dialogue-shadow').removeClass('hidden');
    check_to_hide_or_show_add_link($dialogue.find("[data-limit], [data-min]"));
  });

  $('.edit').on('click', '.editPartsDialogue-close', function(e){
    e.preventDefault();
    update_inputs($(this).parent());
    $(this).parents(".dialogue").addClass('hidden');
    $('.dialogue-shadow').addClass('hidden');
    $('body').removeClass('no-scroll');
  });

  $('.edit').on('change', '[name$="[is_required]"]', function (e) {
    if($(this).is(':checked')){
      $(this).parents('.field_box').find(".is_required").removeClass('hidden');
    }else{
      $(this).parents('.field_box').find(".is_required").addClass('hidden');
    }
  });

  $('.dialogue-shadow').on('click', function(e){
    update_inputs($('.editPartsDialogue').not('.hidden'));
    $('.editPartsDialogue').addClass('hidden');
    $('.dialogue-shadow').addClass('hidden');
    $('body').removeClass('no-scroll');
  });

  $('.sortable').on('change', '[name^="meeting[field_boxes_attributes]"][name$="[name]"]:not([name*="field_input_options_attributes"])', function(){
    $(this).parents('.field_box').find('.field_information .name').text($(this).val());
    if ($(this).parents('.field_box').find('.field_information [name^="sample"]').length == 1){
      $(this).parents('.field_box').find('.field_information [name^="sample"]').attr('placeholder', $(this).val());
    }
  });

  $('.sortable').on('change', '[name^="meeting[field_boxes_attributes]"][name$="[description]"]', function () {
    $(this).parents('.field_box').find('.field_information .description').text($('<div>').html($(this).val()).text());
  });

  $('.editField').on('change', '[id$="_is_required"]', function(){
    $(this).parents('.field_inputs').find('[id$="_is_required"]').prop("checked", $(this).prop("checked"));
  });

  $('.editField').on('change', '[id$="_is_used_for_receipt"]', function () {
    $(this).parents('.field_inputs').find('[id$="_is_used_for_receipt"]').prop("checked", $(this).prop("checked"));
  });

  $('.editField').on('change', '[id$="_is_used_for_receipt_name"]', function () {
    $(this).parents('.field_inputs').find('[id$="_is_used_for_receipt_name"]').prop("checked", $(this).prop("checked"));
  });

  $('.editField').on('change', '[id$="_is_used_for_name_plate"]', function () {
    $(this).parents('.field_inputs').find('[id$="_is_used_for_name_plate"]').prop("checked", $(this).prop("checked"));
  });

  InsertField();
  FieldsList();
  FieldPreset();

  JpZip();
  if (document.querySelector('.headline')) {
    Notifications();
  }

  $(document)
    .on('cocoon:after-insert', "[data-limit], [data-min]", function(){ check_to_hide_or_show_add_link($(this)); })
    .on('cocoon:after-remove', "[data-limit], [data-min]", function(){ check_to_hide_or_show_add_link($(this)); });
  $("[data-limit], [data-min]").each(function(){ check_to_hide_or_show_add_link($(this)); });

  $(".visitor_types").on('cocoon:after-insert', function(){
    var visitorTypeFields = document.querySelectorAll(".date_time_picker_wrap");
    flatpickr(visitorTypeFields[visitorTypeFields.length-1], {
      enableTime: true,
      altInput: true,
      altFormat: "Y/m/d H:i",
      dateFormat: "Y-m-dTH:i:00",
      time_24hr: true,
      wrap: true
    });
    flatpickr(visitorTypeFields[visitorTypeFields.length-2], {
      enableTime: true,
      altInput: true,
      altFormat: "Y/m/d H:i",
      dateFormat: "Y-m-dTH:i:00",
      time_24hr: true,
      wrap: true
    });
    flatpickr(".date_time_picker_wrap", {
      enableTime: true,
      altInput: true,
      altFormat: "Y/m/d H:i",
      dateFormat: "Y-m-dTH:i:00",
      time_24hr: true,
      wrap: true,
    });
    updateReorderControls($(this));
  });

  $(".visitor_type_options").on('cocoon:after-insert', function () {
    flatpickr(".date_time_picker_wrap", {
      enableTime: true,
      altInput: true,
      altFormat: "Y/m/d H:i",
      dateFormat: "Y-m-dTH:i:00",
      time_24hr: true,
      wrap: true,
    });
    updateReorderControls($(this));
  });
  $(".visitor_types, .visitor_type_options").on('cocoon:after-remove', function(){
    updateReorderControls($(this));
  });
  updateReorderControls($(".visitor_types"));
  updateReorderControls($(".visitor_type_options"));

  $(".embedded")
    .on('cocoon:after-insert', function(){ update_amount(); })
    .on('cocoon:after-remove', function(){ update_amount(); })
    .on('change', "[name$='[visitor_type]']", function(){ update_amount(); })
    .on('change', "[name$='[visitor_type_option_ids][]']", function () { update_amount(); });

  $(".baseField input").on("change", function(){
    if($(".step2").hasClass('close')){
      $(".step2 .priceField").slideDown('400', function() {
        $(".step2").removeClass('close');
      });
    }
    updateReorderControls($(".visitor_types"));
  });

  $(".priceField input").on("change", function(){
    if($(".step3").hasClass('close')){
      $(".step3 .editField").slideDown('400', function() {
        $(".step3").removeClass('close');
      });
    }
    if($(".step4").hasClass('close')){
      $(".step4 .completeField").slideDown('400', function() {
        $(".step4").removeClass('close');
        $("input[type=submit]").prop('disabled', false);
      });
    }
  });

  $('form.edit_meeting, form.new_meeting').on('submit', function(e){
    var cnt = 0;
    $('[name$="[rank]"]').each(function(){
      $(this).val(cnt);
      cnt++;
    });
  });

  $('#meeting_visitor_mail_description').on('change', function(e){
    $('.sample_visitor_mail_description').text($('#meeting_visitor_mail_description').val());
  });
  $('#meeting_visitor_name_description').on('change', function (e) {
    $('.sample_visitor_name_description').text($('#meeting_visitor_name_description').val());
  });

  if (document.getElementById("bank_account_bank_code") != null) {
    var bank_sel_str = "#bank_account_bank_code"
    new Selectr(bank_sel_str, {
      defaultSelected: false,
      placeholder: $(bank_sel_str).data("placeholder"),
      messages: {
        noOptions: $(bank_sel_str).data("nooptions"),
        noResults: $(bank_sel_str).data("noresults"),
      }
    })
    var branch_sel_str = "#bank_account_branch_code"
    var branch_sel = new Selectr(branch_sel_str, {
      defaultSelected: false,
      placeholder: $(branch_sel_str).data("placeholder"),
      messages: {
        noOptions: $(branch_sel_str).data("nooptions"),
        noResults: $(branch_sel_str).data("noresults"),
      }
    })
    $("#bank_account_bank_code").on('change', function () {
      const bank_code = $(this).val();
      $.ajax({
        url: `/user/bank_account/branches/${bank_code}`,
        type: 'GET'
      }).done((data) => {
        const $el = $("#bank_account_branch_code");
        $el.empty();
        branch_sel.removeAll();
        $.each(data, function (key, value) {
          branch_sel.add({ text: key, value: value })
          $el.append($("<option></option>").attr("value", value).text(key));
        });
        branch_sel.setValue($("#selected_branch_code").val());
      });
    });
    $("#bank_account_bank_code").trigger('change');
  }

  update_amount();
});

function animateReorder($item, $target, direction){
  if(!$target || $target.length === 0)return;
  var $container = $item.closest('.formParts');
  if($container.hasClass('is-reordering'))return;

  var scrollY = window.pageYOffset || document.documentElement.scrollTop;
  var $items = $container.find('.nested-fields:visible');
  var before = new Map();
  $items.each(function(){
    before.set(this, this.getBoundingClientRect().top);
  });

  $container.addClass('is-reordering');
  if(direction === 'up'){
    $item.insertBefore($target);
  }else{
    $item.insertAfter($target);
  }
  updateReorderControls($container);

  window.scrollTo(0, scrollY);

  var $afterItems = $container.find('.nested-fields:visible');
  $afterItems.each(function(){
    var prevTop = before.get(this);
    if(prevTop === undefined)return;
    var deltaY = prevTop - this.getBoundingClientRect().top;
    if(deltaY === 0)return;
    this.style.transition = 'none';
    this.style.transform = `translateY(${deltaY}px)`;
  });

  void $container.get(0).offsetHeight;

  $afterItems.each(function(){
    if(!this.style.transform)return;
    this.style.transition = 'transform 220ms ease';
    this.style.transform = '';
  });

  setTimeout(function(){
    $afterItems.each(function(){
      this.style.transition = '';
      this.style.transform = '';
    });
    $container.removeClass('is-reordering');
  }, 220);
}

$(document).on('click', '.visitor_types .move-up, .visitor_type_options .move-up', function(){
  var $item = $(this).closest('.nested-fields');
  var $prev = $item.prevAll('.nested-fields:visible').first();
  animateReorder($item, $prev, 'up');
});

$(document).on('click', '.visitor_types .move-down, .visitor_type_options .move-down', function(){
  var $item = $(this).closest('.nested-fields');
  var $next = $item.nextAll('.nested-fields:visible').first();
  animateReorder($item, $next, 'down');
});

function check_to_hide_or_show_add_link($el){
  if($el.find('.nested-fields:visible').length >= $el.data('limit')){
    $el.find('a').hide();
  }else{
    $el.find('a').show();
  }

  if($el.find('.nested-fields:visible').length <= $el.data('min')){
    $el.find('.remove_fields').hide();
  }else{
    $el.find('.remove_fields').show();
  }
}

function update_inputs($dialogue){
  $dialogue.parent().find('.field_input').each(function(){
    var tmp = [];
    $(this).find('.field_input_option').each(function(){
      if($(this).css('display') != 'none')tmp.push($(this).find('input[type="text"]').val());
    });

    var $tmphtml = $();
    const type = $(this).find('input[name$="[input_type]"]').val();
    switch(type){
      case "select":
        $tmphtml = $tmphtml.add($("<select>",{ disabled: "disabled" }));
        tmp.forEach(function(v){
          $tmphtml.append(`<option>${v}</option>`);
        });
        break;
      case "check_boxes":
        tmp.forEach(function(v){
          $tmphtml = $tmphtml.add($(`<span class="collection_item"><input class="check_boxes" disabled type="checkbox" name="sample[]"><label>${v}</label></span>`));
        });
        break;
      case "radio_buttons":
        tmp.forEach(function(v){
          $tmphtml = $tmphtml.add($(`<span class="collection_item"><input class="radio_buttons" disabled type="radio" name="sample[]"><label>${v}</label></span>`));
        });
        break;
      default:
        return;
    }
    $(this).parents('.field_box').find('.sample').find('.formBox').html($tmphtml);
  });
}

function update_amount(){
  if($('#embedded-confirm').length>0)return;
  var amount = 0;
  var has_error = false;
  var visitor_count = 0;
  $('.embedded .visitor_type').each(function(){
    var type_id = $(this).data('type');
    var count = $(`input[value='${type_id}']:checked`).length;
    visitor_count += count;
    var price = $(this).data('price').toString().replace(/,/g, "");

    $(this).find('.count').text(count);
    if(count>parseInt($(this).data('limit'))){
      $(this).find('.count_error').text(visitors_limit);
      has_error = true;
    }else{
      $(this).find('.count_error').text('');
    }
    var tmp = $(this).find('.price').text().replace(/[0-9,]+/g ,count*price).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    $(this).find('.price').text(tmp);
    amount += count*price;
  });

  if ($('.nested-fields.visitor').length < 2) {
    $('h2.visitor_count').first().addClass('hidden_counter');
  } else {
    $('h2.visitor_count').first().removeClass('hidden_counter');
  }

  $('.embedded .visitor_type_option').each(function () {
    var type_id = $(this).data('type');
    var count = $(`input[value='${type_id}']:checked`).length;
    var price = $(this).data('price').toString().replace(/,/g, "");

    $(this).find('.count').text(count);
    var tmp = $(this).find('.price').text().replace(/[0-9,]+/g, count * price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    $(this).find('.price').text(tmp);
    amount += count * price;
  });
  if (visitor_count > parseInt($("[data-remaining]").data('remaining'))) {
    $("[data-remaining] .count_error").text(visitors_limit);
    has_error = true;
  } else {
    $("[data-remaining] .count_error").text('');
  }
  $("#pay_button").prop('disabled', has_error);
  $("#join_button").prop('disabled', has_error);
  var tmp = $('.amount').text().replace(/[0-9,]+/g ,amount).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  $('.amount').text(tmp);
  $("#amountHidden").val(amount);
  if(typeof paymentRequest !== 'undefined'){
    paymentRequest.update({ total: { label: $(".eventName").text(), amount: amount } });
  }
  if(amount==0){
    $(".charge-box").hide();
    $("#payment-request-button").hide();
    $("#or").hide();
    $(".join-box").show();
  }else{
    $(".charge-box").show();
    $("#payment-request-button").show();
    $("#or").css('display', 'flex');
    $(".join-box").hide();
  }

}

function updateReorderControls($container){
  if(!$container || $container.length === 0)return;
  $container.each(function(){
    var $list = $(this);
    var $items = $list.find('.nested-fields:visible');
    $items.each(function(index){
      var $item = $(this);
      var $up = $item.find('.move-up');
      var $down = $item.find('.move-down');
      $up.toggleClass('is-placeholder', index === 0);
      $down.toggleClass('is-placeholder', index === $items.length - 1);
      var $rankInput = $item.find('input[type="hidden"][name$="[rank]"]').first();
      if($rankInput.length){
        $rankInput.val(index);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./app/javascript/packs/index.js